import { useCallback, useEffect, useRef, useState } from 'react';

const useInterval = (intervalFunction, delayMs, cancelOnUnmount = true) => {
  const interval = useRef();
  const callback = useRef(intervalFunction);
  const [isCleared, setIsCleared] = useState(false);

  const cleanup = useCallback(() => {
    if (interval.current) {
      setIsCleared(true);
      clearInterval(interval.current);
    }
  }, []);

  useEffect(() => {
    callback.current = intervalFunction;
  }, [intervalFunction]);

  useEffect(() => {
    interval.current = setInterval(() => {
      callback.current();
    }, delayMs);

    return cleanup;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delayMs]);

  useEffect(() => {
    return () => {
      if (cancelOnUnmount) {
        cleanup();
      }
    };
  },[cancelOnUnmount, cleanup]);

  return { isCleared, cleanup };
};

export default useInterval;
